export default "/images/framework/BackNoShadow.a4cbb925.svg?a4cbb925";